module.exports = __webpack_public_path__ + "media/contact.9a518161.mp4";